import gql from 'graphql-tag';

const GET_EMERGENCY_CONTACTS_BY_WORKSPACE_ID = gql`
  query GetEmergencyContactByWorkspaceId($workspaceId: ID!) {
    getEmergencyContactByWorkspaceId(workspaceId: $workspaceId) {
      emergencyContacts {
        id
        type
        name
        workspaceId
        note
        phoneNumbers
        contactIdentifier
        email
        confirmation_code
        duress_code
        cra_code
        image
        custom {
          id
          type
          name
          note
          phoneNumbers
          contactIdentifier
          email
          confirmation_code
          duress_code
          cra_code
        }
        isDefault
      }
    }
  }
`;

const GET_EMERGENCY_CONTACTS_BY_SITUATION_ID = gql`
  query GetEmergencyContactsBySituationId($situationId: ID!) {
    getEmergencyContactsBySituationId(situationId: $situationId) {
      id
      name
      emergencyContacts {
        id
        type
        name
        phoneNumbers
        note
        contactIdentifier
        email
        confirmation_code
        duress_code
        cra_code
      }
    }
  }
`;

export default {
  GET_EMERGENCY_CONTACTS_BY_WORKSPACE_ID,
  GET_EMERGENCY_CONTACTS_BY_SITUATION_ID,
};
